/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { Box, Grid } from '@mui/material';
import BackButton from '../../../../../components/shared/Buttons/BackButton';
import MainCard from '../../../../../components/ui-elements/cards/MainCard';
import NetworkStatus from '../views/networkStatus';

const ManageNetworkPage = () => {
    return (
        <>
            <Box m={6}>
                <Grid container spacing={4} >
                    <Grid item xs={12} sm={12} md={12}>
                        <BackButton pageTitle={'Manage Network'} />
                    </Grid>

                </Grid>
                <MainCard>
                    <Grid container spacing={4} sx={{ p: 8 }} >
                        <NetworkStatus />

                    </Grid>
                </MainCard>
            </Box>

        </>
    )
}

export default ManageNetworkPage;